/* 1992 - one-tap adds from the cart drawer (quick picks + GOES WITH THIS).
   Event delegation on document so handlers survive every drawer re-render. */
(function () {
  function rootPath() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function renderDrawer() {
    fetch(rootPath() + '?sections=cart-icon-bubble,cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        var bubble = document.getElementById('cart-icon-bubble');
        if (bubble && sections['cart-icon-bubble']) {
          var d = document.createElement('div');
          d.innerHTML = sections['cart-icon-bubble'];
          var next = d.querySelector('.shopify-section') || d;
          bubble.innerHTML = next.innerHTML;
        }
        var drawer = document.querySelector('cart-drawer');
        if (drawer && sections['cart-drawer']) {
          var wrap = document.createElement('div');
          wrap.innerHTML = sections['cart-drawer'];
          var inner = wrap.querySelector('cart-drawer');
          if (inner) drawer.innerHTML = inner.innerHTML;
          drawer.classList.remove('is-empty');
          if (typeof drawer.open === 'function') drawer.open();
              var overlay = drawer.querySelector('#CartDrawer-Overlay');
              if (overlay && typeof drawer.close === 'function') overlay.addEventListener('click', drawer.close.bind(drawer));
        }
      })
      .catch(function () {});
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-1992-quick-add]');
    if (!btn) return;
    e.preventDefault();
    if (btn.disabled) return;
    btn.disabled = true;
    fetch(rootPath() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(btn.dataset.vid, 10), quantity: 1 }] })
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      return r.json();
    }).then(renderDrawer).catch(function () {
      btn.disabled = false;
    });
  });
})();
